export default "__VITE_ASSET__CSyxrH_$__"